import PropTypes from 'prop-types';
import RequestSentIcon from '../icons/RequestSentIcon';
import GS from '../../grafsync/grafsync';
import { makeCancelable } from '../../core/utils/utils';
import { withRouter } from 'react-router-dom';
import BasicLayout from '../BasicLayout';
import PrimaryButton from '../PrimaryButton';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { globalStyles as styles } from '../style/gstheme';

// We put it at 12 to give a bit of wiggle room
const MAX_WAIT_TIME = 720;

class SubscriptionSuccess extends Component {

  constructor(props) {
    super(props);
    this.state = {
      startTime: Date.now(),
      problemApproving: false,
      isErrored: false,
      almostReady: false,
      disabled: false,
      checking: true,
      subscription: null,
      bucket: null
    };
    this.cancellable = null;
  }

  componentDidMount() {
    this.hcTimeout = setTimeout(() => { this.checkStatus(); }, 2000);
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
  }

  checkStatus = async (stackCreated = false) => {
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
    try {
      const response = await this.doCheckStatus().promise;
      if (response.length === 0) stackCreated = true;
      if (this.cancellable && this.cancellable.isCancelled()) return;
      const newSubscription = response.find(subscription => subscription.id === this.props.subscription);
      if (newSubscription && newSubscription.approved && newSubscription.active) {
        // We need a slight delay to let routing settle down if a new stack has been created
        const wait = stackCreated ? 120000 : 5000;
        this.setState({ almostReady: true }, () => {
          setTimeout(() => this.setState({ checking: false }), wait);
        });
      }
      else {
        // In the first call we wouldn't have known which bucket the subscription is assigned to
        // But any server responding will include that information which we record to route future checks
        if (newSubscription) {
          this.setState({ bucket: newSubscription.subscriptionBucket });
        }
        const timeNow = Date.now();
        if (timeNow - this.state.startTime > (MAX_WAIT_TIME * 1000)) {
          this.setState({ problemApproving: true });
        }
        else {
          this.hcTimeout = setTimeout(() => {
            this.props.resetIdle();
            this.checkStatus(stackCreated);
          }, 5000);
        }
      }
    }
    catch (e) {
      if (this.cancellable && this.cancellable.isCancelled()) return;
    }
  };

  doCheckStatus() {
    this.cancellable = makeCancelable(GS.subscriptions(this.state.bucket, true));
    return this.cancellable;
  }

  problemProceed = () => {
    this.props.onFail();
    this.props.history.push("/");
  };

  proceed = () => {
    this.props.onContinue();
    this.props.history.push("/");
  };

  render() {

    const { classes, onGoHome } = this.props;
    const { checking, problemApproving, almostReady } = this.state;

    return (
      <BasicLayout onGoHome={onGoHome}>
        <div style={{ textAlign: 'center', paddingTop: 100 }}>
          <Typography className={classes.accessHeadingHighlighted}>Vocabulary and Ontology Management</Typography>
          {checking ?
            <div style={{ marginTop: '30px' }}>
              <div style={{ marginBottom: '12px' }}>
                <RequestSentIcon style={{ width: '36px', height: '32px' }} />
              </div>
              <Typography paragraph variant="h3" className={classes.mainHeadingSecondary}>Setting up Your Subscription</Typography>
              {problemApproving ?
                <div>
                  <Typography variant="body2" paragraph style={{ color: '#DD2C00' }}>It is taking longer than expected to set up your subscription.</Typography>
                  <Typography variant="body2" paragraph style={{ color: '#DD2C00' }}>Please contact support.</Typography>
                  <PrimaryButton dataTest="creation-continue" onClick={this.problemProceed}>Continue</PrimaryButton>
                </div>
                :
                almostReady ?
                  <Typography variant="body2">Finishing up. Almost there!</Typography>
                  :
                  <Typography variant="body2">Please wait. This may take up to 12 minutes.</Typography>
              }
            </div>
            :
            <div style={{ marginTop: '30px' }}>
              <Typography variant="h2" className={classes.subMainHeading}>Subscription Created</Typography>
              <PrimaryButton dataTest="creation-continue" onClick={this.proceed}>Continue</PrimaryButton>
            </div>
          }
        </div>
      </BasicLayout>
    );
  }
}

SubscriptionSuccess.propTypes = {
  classes: PropTypes.object,
  onGoHome: PropTypes.func,
  subscription: PropTypes.string,
  subscriptions: PropTypes.string,
  onContinue: PropTypes.func.isRequired,
  onFail: PropTypes.func.isRequired,
  resetIdle: PropTypes.func.isRequired,
  history: PropTypes.object
};

export default withRouter(withStyles(styles)(SubscriptionSuccess));